import { createSlice } from '@reduxjs/toolkit';

// Initialize based on localStorage or device language
const detectLanguage = () => {
  try {
    // 1. Check localStorage first
    const savedLang = typeof localStorage !== 'undefined' ? localStorage.getItem('language') : null;
    if (savedLang) {
      return savedLang;
    }

    // 2. Check device language
    const lang = (typeof navigator !== 'undefined' && navigator.language)
      ? navigator.language.toLowerCase()
      : 'en';
    return lang.startsWith('ar') ? 'ar' : 'en';
  } catch (_) {
    return 'en';
  }
};

const initialLanguage = detectLanguage();

const initialState = {
  selectedLanguage: initialLanguage,
  direction: initialLanguage === 'ar' ? 'rtl' : 'ltr'
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.selectedLanguage = action.payload;
      state.direction = action.payload === 'ar' ? 'rtl' : 'ltr';
      
      // Update document attributes
      document.documentElement.dir = state.direction;
      document.documentElement.lang = action.payload;
      
      // Save to localStorage
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('language', action.payload);
      }
    }
  }
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;